import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { trackById } from '../../../shared/util/track-by.util';
import { ITag } from '../../../tag/interfaces/tag.interface';
import { SalesOrderViewSettingsService } from '../../services/sales-order-view-settings.service';

@Component({
  selector: 'lum-sales-order-tag-cell-renderer',
  templateUrl: './sales-order-tag-cell-renderer.component.html',
  styleUrls: ['./sales-order-tag-cell-renderer.component.scss'],
})
export class SalesOrderTagCellRendererComponent
  implements ICellRendererAngularComp, OnDestroy, OnInit
{
  readonly #destroy$ = new Subject<void>();

  #tags :ITag[] = [];

  prefersTagsCollapsed :boolean = false;
  tags :ITag[] = [];
  limit :number = 1;
  trackById = trackById;

  constructor(
    private _cd :ChangeDetectorRef,
    private _viewSettings :SalesOrderViewSettingsService,
  ) {}

  ngOnDestroy() :void {
    this.#destroy$.next();
    this.#destroy$.complete();
  }
  ngOnInit() :void {
    this.#initViewSettings();
  }

  agInit(params :ICellRendererParams) :void {
    // the input is saved unchanged in a private var
    this.#tags = params.data?.tags;
    // the public var (for the template) is only for data that has been properly
    // prepared for consumption in the template.
    this.tags = this.#tags?.map((tag) => this.prepareTagForDisplay(tag)) ?? [];
  }

  prepareTagForDisplay(tag :ITag) :ITag {
    return {
      ...tag,
      color: tag.color?.trim?.() ? tag.color : '#008000',
      name: tag.name?.trim() || '[unnamed tag]',
    };
  }

  refresh(params :any) :boolean {
    return false;
  }

  #initViewSettings() {
    this._viewSettings.state
      .observe('prefersTagsCollapsed')
      .pipe(takeUntil(this.#destroy$))
      .subscribe((prefersTagsCollapsed :boolean) => {
        this.prefersTagsCollapsed = prefersTagsCollapsed;
        this._cd.detectChanges();
      });
  }
}
